<template>
  <v-card outlined rounded="xl" class="rh-etapa-card" :style="estiloCard">
    <v-card-title
      class="px-4 px-sm-6 pt-5 pt-sm-6 pb-2 d-flex align-center justify-space-between flex-wrap gap-2"
    >
      <div class="d-flex align-center rh-etapa-card__cabecalho">
        <v-avatar size="46" class="rh-etapa-card__icone mr-3">
          <v-icon color="primary">{{ icone }}</v-icon>
        </v-avatar>
        <div class="rh-etapa-card__textos">
          <div class="text-h6 font-weight-bold primary--text">
            {{ titulo }}
          </div>
          <div class="text-caption grey--text rh-etapa-card__subtitulo">
            {{ subtitulo }}
          </div>
        </div>
      </div>
      <div class="d-flex align-center">
        <slot name="acoes" />
      </div>
    </v-card-title>

    <v-divider class="mx-4 mx-sm-6 mt-3" />

    <v-card-text class="px-4 px-sm-6 pt-4 pb-6">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RhEtapaCard",
  props: {
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: String,
      default: "",
    },
    icone: {
      type: String,
      required: true,
    },
    destaque: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    estiloCard() {
      if (!this.destaque) {
        return null;
      }
      return {
        border: "1px solid var(--brand-border)",
        backgroundColor: "var(--brand-soft)",
      };
    },
  },
};
</script>

<style scoped>
.rh-etapa-card {
  border: 1px solid var(--border);
  transition: box-shadow 180ms ease, transform 180ms ease;
}

.rh-etapa-card:hover {
  box-shadow: 0 8px 30px var(--shadow);
}

.rh-etapa-card__cabecalho {
  flex: 1 1 260px;
  min-width: 0;
}

.rh-etapa-card__textos {
  min-width: 0;
  word-break: normal;
}

.rh-etapa-card__subtitulo {
  line-height: 1.35;
}

.rh-etapa-card__icone {
  background: var(--brand-soft);
  border: 1px solid var(--brand-border);
}

.gap-2 {
  gap: 12px;
}
</style>
